import axios from "../tools/axiosHcp.js";

function getMyFacility(url) {
	return axios.get(`${url}/myfacility`)
}

function getAllFacilities(url) {
	return axios.get(`${url}/GetAll`)
}

function formatFacilityAddress(facility) {
	// build part 1 of the address
	let address1Parts = [];
	if (facility.address) {
		address1Parts.push(facility.address);
	}
	if (facility.address2) {
		address1Parts.push(facility.address2);
	}
	let address1 = address1Parts.join(' ');

	// build part 2 of the address
	let address2Parts = [];
	if (facility.city) {
		address2Parts.push(facility.city);
	}
	if (facility.state) {
		address2Parts.push(facility.state);
	}
	if (facility.zipCode) {
		address2Parts.push(facility.zipCode);
	}
	let address2 = address2Parts.join(' ');

	// build the complete address
	let addressParts = [];
	if (address1) {
		addressParts.push(address1);
	}
	if (address2) {
		addressParts.push(address2);
	}
	return addressParts.join(', ');
}

export default {
	getMyFacility: getMyFacility,
	getAllFacilities: getAllFacilities,
	formatFacilityAddress: formatFacilityAddress
};
